export default __webpack_public_path__ + "static/media/Microcef-200-eng.34b8b01c.jpg";